// 4 Nov 2026 (RK): a buyer typed "…@gmail.comcomil.com" and never got his ebook. Spot typos in common mail
// domains while people type and offer the fix. Same rules as email_suggestion() in the backend.
const DOMAINS = ["gmail.com", "yahoo.com", "yahoo.in", "yahoo.co.in", "hotmail.com", "outlook.com", "icloud.com",
    "rediffmail.com", "live.com", "protonmail.com", "googlemail.com", "msn.com", "aol.com", "zoho.com", "me.com", "outlook.in", "hotmail.co.in", "live.in", "ymail.com", "rocketmail.com"];
const FIX = { "gmail.co": "gmail.com", "gmail.cm": "gmail.com", "gmail.om": "gmail.com", "gmail.con": "gmail.com",
    "gmail.in": "gmail.com", "gmail.co.in": "gmail.com", "gmail.coom": "gmail.com", "gmail.comm": "gmail.com",
    "gmai.com": "gmail.com", "gmial.com": "gmail.com", "gamil.com": "gmail.com", "gmal.com": "gmail.com",
    "gmil.com": "gmail.com", "gnail.com": "gmail.com", "gmaill.com": "gmail.com", "gimail.com": "gmail.com",
    "yaho.com": "yahoo.com", "yahooo.com": "yahoo.com", "yahoo.co": "yahoo.com", "hotmai.com": "hotmail.com",
    "hotmial.com": "hotmail.com", "outlok.com": "outlook.com", "icloud.co": "icloud.com", "rediff.com": "rediffmail.com" };
const RE = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

function lev(a, b) {
    if (Math.abs(a.length - b.length) > 3) return 9;
    let prev = Array.from({ length: b.length + 1 }, (_, i) => i);
    for (let i = 1; i <= a.length; i++) {
        const cur = [i];
        for (let j = 1; j <= b.length; j++) cur.push(Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + (a[i - 1] !== b[j - 1] ? 1 : 0)));
        prev = cur;
    }
    return prev[b.length];
}

export function validEmail(e) { return RE.test(String(e || "").trim()); }

export function emailSuggestion(email) {
    const e = String(email || "").trim().toLowerCase();
    if (!validEmail(e)) return "";
    const at = e.lastIndexOf("@");
    const local = e.slice(0, at), dom = e.slice(at + 1);
    if (DOMAINS.includes(dom)) return "";
    if (FIX[dom]) return `${local}@${FIX[dom]}`;
    for (const g of DOMAINS) if (dom.startsWith(g) && dom !== g) return `${local}@${g}`;
    let best = "", bd = 9;
    for (const g of DOMAINS) { const d = lev(dom, g); if (d < bd) { best = g; bd = d; } }
    if (bd <= 2 && dom.length >= 6) return `${local}@${best}`;
    if (["gmail", "gmai", "gmial", "gamil", "yahoo", "hotmail", "outlook"].includes(dom.split(".")[0])) return `${local}@${best || "gmail.com"}`;
    return "";
}
